export default __webpack_public_path__ + "static/media/infoGrey.1b9ef9fd.svg";